module.exports = __webpack_public_path__ + "static/media/android-download.f9b3c656.png";